const admissionsData = {
  director: {
    id: 1,
    name: "Prof. N. Narasimhulu",
    qualifications: "M.A, M.Phil, Ph.D",
    position: "In-charge, Director, Directorate of Admissions",
    department: "Professor & Head, Dept. of Telugu",
    email: "doa.ru18@gmail.com",
    image: "/person/Narasimhulu.JPG", // Place image in public/person/ folder
    office: "Directorate of Admissions"
  },
};

export default admissionsData;